"use client";

import dynamic from "next/dynamic";
import type { LeafletMapProps } from "./LeafletMap";

const LeafletMap = dynamic(
  () => import("./LeafletMap"),
  { ssr: false }
);

export default function LeafletMapWrapper(props: LeafletMapProps) {
  return <LeafletMap {...props} />;
}
